import React, { Component } from 'react';
import { Checkbox } from 'antd'
import { permissions } from './../../../../../constants'
import handlePermission from './../../../../app/handlePermission'

import styles from './styles.css'

const TITLE_LIST = [
    {
        key: 'SKU',
        value: 'SKU'
    },
    {
        key: 'ItemCode',
        value: 'Channel Item Code'
    },
    {
        key: 'ItemName_US',
        value: 'ITEM NAME-EN'
    },
    {
        key: 'ItemName_JP',
        value: 'ITEM NAME-JP'
    },
    {
        key: 'CountryOfOriginCH',
        value: 'Origin'
    },
    {
        key: 'Item_weight',
        value: 'Weight'
    }
]

class HeaderItemName extends Component {
    constructor(props) {
        super(props)
        this.state = {
            setPermission: !handlePermission(permissions.ItemNameUpdateItemName) ? true : false
        }
    }

    render() {
        const { handleSort, sortParams, collectIdItemCurrent, DefaultWeightUnitCH } = this.props

        return (
            <thead className="item-name-header-container">
                <tr>
                    <th className='checkbox'>
                        <Checkbox
                            onChange={(e) => this.props.checkedAll(e.target.checked)}
                            checked={this.props.valueCheckox}
                            disabled={this.state.setPermission || !collectIdItemCurrent.length}
                        />
                    </th>
                    {
                        TITLE_LIST.map(item => (
                            item.key === 'Item_weight' ?
                            <th key={item.key} className='col-title-item-name'>
                                <span className="title-container">
                                    {`${item.value}(${DefaultWeightUnitCH})`}
                                </span>
                            </th> 
                            : 
                            <th key={item.key} className='col-title-item-name'>
                                <span className="title-container">
                                    {item.value}
                                </span>
                            </th> 
                        ))
                    }
                </tr>
            </thead>
        );
    }
}

export default HeaderItemName;



// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/header-item-name/index.js